import { useDeepMemoize } from 'data/utils';
import { DependencyList, useMemo } from 'react';

const useDeepMemo = <T>(factory: () => T, dependencies: DependencyList) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(factory, useDeepMemoize(dependencies));
};

export default useDeepMemo;
